import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface VendorFlaggingState {
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: VendorFlaggingState = {
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

export const vendorFlaggingSlice = createSlice({
  name: 'vendorFlagging',
  initialState,
  reducers: {
    setVendorFlagging: (state, action) => {
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewVendorFlagging: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setVendorFlagging, addNewVendorFlagging, reset } = vendorFlaggingSlice.actions;
export const getVendorFlagging = (state: RootState) => state.vendorFlagging.data;

export default vendorFlaggingSlice.reducer;
